import React, { memo } from 'react'
import { SchedulesProps } from './types'

const Schedules = ({
  children,
  timeIndicatorPosition,
  hiddenListingAtStart,
}: SchedulesProps) => {
  return (
    <div className="epg__schedules">
      {timeIndicatorPosition >= 0 && (
        <div
          className="epg__schedules__time-indicator"
          style={{
            left: `${!hiddenListingAtStart ? '0' : '25px'}`,
            transform: `scale(${timeIndicatorPosition / 100}, 1)`,
          }}
        ></div>
      )}
      {children}
    </div>
  )
}

export default memo(Schedules)
